__turbopack_context__.v({
  "calloutTag": "AnimatedShowcase-module__WByCyW__calloutTag",
  "contentWrapper": "AnimatedShowcase-module__WByCyW__contentWrapper",
  "description": "AnimatedShowcase-module__WByCyW__description",
  "heading": "AnimatedShowcase-module__WByCyW__heading",
  "imageContainer": "AnimatedShowcase-module__WByCyW__imageContainer",
  "imageGallery": "AnimatedShowcase-module__WByCyW__imageGallery",
  "showcase": "AnimatedShowcase-module__WByCyW__showcase",
  "textContent": "AnimatedShowcase-module__WByCyW__textContent",
});
